import { Link } from "react-router-dom";
import { defaultArticles } from "@/mocks/articles";

interface RelatedArticlesProps {
  slugs: string[];
}

export default function RelatedArticles({ slugs }: RelatedArticlesProps) {
  const articles = slugs
    .map((slug) => defaultArticles.find((a) => a.slug === slug))
    .filter(Boolean);

  if (articles.length === 0) return null;

  return (
    <section className="bg-background-100 px-6 md:px-10 py-14 md:py-18">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-10">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-stack-line mr-1.5"></i>
            相关推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这些你可能也感兴趣
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article!.slug}
              to={`/article/${article!.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article!.image}
                  alt={article!.title}
                  title={`${article!.title} - 黑料网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-md mb-2.5">
                  {article!.category}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug mb-2.5 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article!.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article!.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article!.views >= 10000
                      ? `${(article!.views / 10000).toFixed(1)}万`
                      : article!.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}